import React, {useState} from 'react';
import axios from "axios";

const NewGroup = ({agents, authRole, getConversations}) => {
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedUserIds, setSelectedUserIds] = useState([]);
    const [groupName, setGroupName] = useState('');
    console.log('selectedUserIds', selectedUserIds);
    console.log('groupName', groupName);
    const filteredUsers = agents?.filter((user) =>
        user?.name?.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const handleCheckboxChange = (user) => {
        console.log(user);
        setSelectedUserIds(prev =>
            prev.includes(user.id)
                ? prev.filter(id => id !== user.id)
                : [...prev, user]
        );
    };
    const onSubmit = async () => {
        if (!groupName || selectedUserIds.length === 0) {
            alert('Please enter group name and select at least one user.');
            return;
        }

        const admin = authRole === 'agency_admin' ? 1 : 0;
        const role = admin ? 'admin' : 'agent';

        try {
            const response = await axios.post(`/${role}/general-chat/add-group`, {
                group_name: groupName,
                members: selectedUserIds,
            });

            if (response.data) {
                getConversations();
            }
        } catch (error) {
            console.error('Error:', error);
        }
    };


    return (
        <div className="modal-dialog modal-dialog-centered" role="document" id="groupModal">
            <div className="modal-content modal-new-conversation">
                <div className="modal-header pb-2 border-bottom">
                    <h5 className="modal-title" id="modalTitle">New Group</h5>
                    <button type="button" className="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                        <label className="mb-0">Group Name :</label>
                        <input className="form-control" name="group_name" type="text"
                               placeholder="Add Group Name"
                               onChange={(e) => setGroupName(e.target.value)}
                               value={groupName}
                               required/>
                        <input type="text" className="form-control mt-2 search-input" id="searchInput"
                               placeholder="search"
                               onChange={(e) => setSearchTerm(e.target.value)}/>
                        <div className="mt-1" style={{maxHeight: '500px', overflowY: 'auto'}} id="userList">
                            {filteredUsers.map(user => {

                                return (
                                    <div
                                        key={user.id}
                                        className="list-group user-chat-list-select list-with-filter"
                                        onClick={() => handleCheckboxChange(user)}
                                        style={{cursor: 'pointer'}}
                                    >
                                        <label
                                            className="list-group-item user-chat-list-select__list-item d-flex align-items-center"
                                            style={{height: '50px'}}
                                        >
                                            <div className="new-conversation-img-status position-relative mr-2">
                                                <div className="new-conversation-img-status__inner">
                                                    <img
                                                        src={user.avatar_image}
                                                        className="rounded-circle"
                                                        width="40"
                                                        height="40"
                                                        alt=""
                                                    />
                                                </div>
                                            </div>
                                            <div>
                                                <span className="add-user-contact-name">{user.name} ({user.role})</span>
                                                <div>{user.email}</div>
                                            </div>
                                            <div>{user.cus_role == 1 && <div>({user.role})</div>}</div>
                                            <div className="ml-auto">
                                                <input type="checkbox"/>
                                            </div>
                                        </label>
                                    </div>
                                );
                            })}

                            <div id="noUserMessage" className="d-none text-center mt-2">No User</div>
                        </div>
                        <div className="py-2 px-3 border-top align-items-center d-flex justify-content-between">
                            <button type="button" className="btn btn-light btn-7" data-dismiss="modal"
                                    aria-label="Close">Cancel
                            </button>
                            <button type="submit" data-dismiss="modal" onClick={onSubmit} className="btn bg-color text-white">Submit</button>
                        </div>
                </div>
            </div>
        </div>
    )
};

export default NewGroup;
